import React, { useState } from "react";
import { Button, IconWrap } from "./styled";
import PT from "prop-types";
import AngleRightIcon from "_c/icon/AngleRight";
import loadable from "@loadable/component";

const BaseCollapse = loadable(() => import("react-collapse"), {
  resolveComponent: (c) => c.Collapse,
});

const Collapse = (props) => {
  return (
    <>
      <Button
        style={props.style}
        type="button"
        className={props.className}
        onClick={props.onClick}
        aria-label={props.title}
        aria-expanded={props.isOpen}
      >
        <IconWrap isOpen={props.isOpen}>
          <AngleRightIcon color="white" />
        </IconWrap>
        <h2>{props.title}</h2>
      </Button>
      <BaseCollapse isOpened={props.isOpen}>{props.children}</BaseCollapse>
    </>
  );
};
Collapse.propTypes = {
  onClick: PT.func,
  isOpen: PT.bool,
  title: PT.string,
};
export const UncontrolledCollapse = ({ defaultOpen, ...props }) => {
  const [open, setOpen] = useState(defaultOpen || false);
  const toggle = () => setOpen((open) => !open);
  return (
    <Collapse isOpen={open} onClick={toggle} {...props}>
      {props.children}
    </Collapse>
  );
};

export default Collapse;
